import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import TeamDetailsSec from '../components/sections/TeamDetailsSec';
import ContactSecOne from '../components/sections/ContactSecOne';

const TeamDetails = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.teamDetailsSec.name" subtitleKey="sections.breadcrumb.team_details.subtitle" />
        <TeamDetailsSec className="space overflow-hidden" />

        <ContactSecOne className="space-bottom overflow-hidden" />
      <Footer />
    </>
  );
};

export default TeamDetails;